import { Button, Flex } from "@chakra-ui/react";
import type { DTO } from "@equidefi/shared/types/dto";

type SavedProfileFormContainerProps = {
  profile: DTO.SavedProfile;
  title?: string;
  subtitle?: string;
  backTo?: string;
  backLabel?: string;
  children: React.ReactNode;
  onSave: () => void;
  isLoading?: boolean;
  isDisabled?: boolean;
};

export function SavedProfileFormContainer({
  children,
  onSave,
  isLoading = false,
  isDisabled = false,
}: SavedProfileFormContainerProps) {
  return (
    <Flex
      direction="column"
      gap={4}
      as="form"
      onSubmit={(e) => {
        e.preventDefault();
        onSave();
      }}>
      {children}

      <Button
        type="submit"
        h="12"
        w="full"
        fontSize="17px"
        fontWeight="700"
        isLoading={isLoading}
        isDisabled={isDisabled}
        borderRadius="lg">
        Save Changes
      </Button>
    </Flex>
  );
}
